export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-format/src/identity.js
// module id = 0tfS
// module chunks = 0